import { goodsPromoteStatusArr } from '@/utils/newDataMap/shopManage';
export const configList = [
	{
		label: '推广状态',
		key: 'other_status',
		type: 'select',
		placeholder: '请选择',
		options: goodsPromoteStatusArr,
		isShow: true,
		clearable: true,
		filterable: true,
		multiple: false,
	},
	{
		label: '团长',
		key: 'authority_id',
		type: 'component',
		component: () => import('@/components/commanderSelect/index.vue'),
		isShow: true,
	},
	{
		label: '未认领商品',
		key: 'is_claim',
		type: 'radio',
		options: [
			{
				label: '是',
				value: '2',
			},
			{
				label: '否',
				value: '0',
			},
		],
		isShow: true,
	},
];
